import { jsx, css } from '@emotion/react';
import celluloseIcon from 'assets/images/insulation/Cellulose.svg';
import fiberglassIcon from 'assets/images/insulation/Fiberglass.svg';
import sprayfoamIcon from 'assets/images/insulation/Sprayfoam.svg';
import { NavLink, useLocation, useHistory } from 'react-router-dom';

import { IconFiberglass, IconCellulose, IconSprayfoam } from './icons';
import Section from '../OC/sections/oc-section';
import { connectLocation } from '../location/LocationConnectors';

const productTileCSS = css`
  display: flex;
  text-align: center;
  font-family: OCRoboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 15px;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px;
  cursor: pointer;

  @media (min-width: 768px) {
    font-size: 16px;
  }

  a {
    display: flex;
    /* width: 256px; */
    flex-direction: column;
    border-bottom: 2px solid #6d6d6d;
    text-decoration: none;
    padding-bottom: 3px;
    width: 100%;

    svg {
      margin-right: auto;
      margin-left: auto;
      padding-top: 16px;
    }

    &.active {
      border-bottom: 5px solid #d40f7d;
      color: #d40f7d;
      padding-bottom: 0;

      svg {
        path {
          fill: #d40f7d;
        }
      }
    }

    &:focus {
      /* outline: none; */
    }
  }

  span {
    @media (max-width: 767px) {
      font-size: 11px;
    }

    margin-top: 18px;
    margin-bottom: 6px;
    font-family: 'OCRoboto';
    text-align: center;
    text-transform: uppercase;
  }
`;
export const XProductTile = ({ t, name, title }) => {
  let url = name;

  if (url === 'fiberglass') url = 'fiberglass-competition';

  const icon = name => {
    {
      if (name === 'fiberglass') {
        return <IconFiberglass />;
      }
      if (name === 'cellulose') {
        return <IconCellulose />;
      }
    }
  };

  // Clear focus outline after tab is selected
  const handleClick = () => {
    document.activeElement.blur();
  };

  return (
    <div css={productTileCSS}>
      <NavLink to={`/propink-vs-${url}`} data-track="tab-click" data-track-tab-name={title} onClick={handleClick}>
        {icon(name)}
        <span>{title}</span>
      </NavLink>
    </div>
  );
};
export const ProductTile = connectLocation(XProductTile);

const productSelectorCSS = css`
  display: flex;
  list-style: none;
  justify-content: space-between;
  max-width: 770px;
  padding: 0;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 40px;
`;

export const ProductSelector = () => {
  const location = useLocation();
  const history = useHistory();
  if (location.pathname === '/ulf-calculator') {
    history.push('propink-vs-fiberglass-competition');
  }
  return (
    <Section anchor="compare">
      <h3 className="body-font center">Select a product to compare against ProPink® L77:</h3>
      <div css={productSelectorCSS}>
        <ProductTile name="fiberglass" title="Fiberglass (ULF)" />
        <ProductTile name="cellulose" title="Cellulose" />
      </div>
    </Section>
  );
};
